import { atom } from 'recoil'

export const localeState = atom<string>({
  key: 'locale',
  default: 'ja',
})
